import { deleteUser } from "@erp/shared/api/generated/wrappers/user";
import { patchUser } from "@erp/shared/api/generated/wrappers/user";
import { postUser } from "@erp/shared/api/generated/wrappers/user";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
export const useMembersAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const readUsersQuery = useQuery(queries.user.all());
    const createUserMutation = useMutation({
        mutationFn: (body) => postUser(body),
        onSuccess: () => {
            showAlert("유저 정보 등록 완료", "완료");
            invalidateQueries([
                queries.user.all().queryKey,
            ]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "유저 정보 등록 실패");
        },
    });
    const updateUserMutation = useMutation({
        mutationFn: ({ id, body }) => patchUser(id, body),
        onSuccess: () => {
            showAlert("유저 정보 수정 완료", "완료");
            invalidateQueries([
                queries.user.all().queryKey
            ]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "유저 정보 수정 실패");
        },
    });
    const deleteUserMutation = useMutation({
        mutationFn: (id) => deleteUser(id),
        onSuccess: () => {
            showAlert("유저 정보 삭제 완료", "완료");
            invalidateQueries([
                queries.user.all().queryKey
            ]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "유저 정보 삭제 실패");
        },
    });
    return {
        readUsersQuery,
        createUserMutation,
        updateUserMutation,
        deleteUserMutation,
    };
};
